import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import moment from 'moment';
import DeleteComponent from '../../action/delete.jsx';
import Swal from 'sweetalert2';
import ExcelExport from './sections/export.jsx';
import { convertTimeToDecimal } from '../../action/timeCalculation.jsx';


const AdminEveTimeLog = () => {
    const currentdate = moment().format("YYYY-MM-DD");

    const [timelogs, setTimeLogs] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [users , setUsers] = useState([]);
    const [filterDept, setFilterDept] = useState('');
    const [filterText, setFilterText] = useState('');
    const [filterDate, setFilterDate] = useState(currentdate);
    const [getUpworkTimings, setUpworkTimings] = useState([]);

    useEffect(() => {
        fetchTimeLogs();
    }, []);

    const fetchTimeLogs = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/timelogs`);
            setDepartments(response.data.data.department);
            setUsers(response.data.data.users);
        } catch (error) {
            console.error("Error fetching time logs!", error);
            setDepartments([]);
            setUsers([]);
        }
    };

    const updateStatus = async ({tlId, approval}) => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/timelog/approval/${tlId}`,{
                approval: approval,
            })
            .then(({data})=>{
                Swal.fire({icon:"success", text:data.message});
                setFilterDate(filterDate);
            }).catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    };


    useEffect(() => {
        axiosInstance.post(`${process.env.REACT_APP_API_URL}/timelogs`, {
            date       : filterDate,
            shift      : 'evening'
        })
        .then(response => {
            setTimeLogs(response.data.data.time_log_data);
            setUpworkTimings(response.data.data.upworkTimings);
        })
        .catch(error => {
            setTimeLogs([]);
            setUpworkTimings([]);
            console.log(error.message);
        });
    }, [filterDate, users]);


    // Filter and group time logs
    const groupByDepartmentAndEmployee = () => {
        return timelogs
            .reduce((acc, item) => {
                if (!acc[item.department]) {
                    acc[item.department] = {};
                }
                if (!acc[item.department][item.user_id]) {
                    acc[item.department][item.user_id] = {
                        logs: [],
                        totalBillable: 0
                    };
                }
                acc[item.department][item.user_id].logs.push(item);

                const time = !(item.deleted_at) && item.total_time_spend;
                
                acc[item.department][item.user_id].totalBillable += convertTimeToDecimal(time || 0);
                return acc;
            }, {});
    };

    const groupedData = groupByDepartmentAndEmployee();

    // Search input handler
    const filteredDepartments = departments.filter((item) => {
        var department = parseInt(filterDept);
        const matchesDept = department ? parseInt(item.id) === department : true;
        return matchesDept;
    });


    return(
        <>
            <div className="content container-fluid">
                <div className="row evnPage">
                    <div className="col-md-6">
                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col evnHeading">
                                    <h3 className="page-title">Evening Time Sheet</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                        <li className="breadcrumb-item active">Evening Time Sheet</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 mt-2" align="right">
                        <div><strong className="h4">Total Upwork Time : </strong>
                                        <span style={{fontSize:'19px'}}> {getUpworkTimings.upworkBillTime || 0} Hours</span></div>
                    </div>
                </div>

                <div className="row">
                    <div className="row">
                        <div className="col-md-9 mb-3">
                            <div className="row">                                
                                <div className="col-md-4 mb-3">
                                    <select className="form-control"
                                        value={filterDept}
                                        onChange={(event) => {setFilterDept(event.target.value)}}>
                                            <option value="">Select Department</option>
                                            {departments.map((dept,index) => (
                                                <option key={index++} value={dept.id}>{dept.name}</option>
                                            ))}
                                    </select>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <input className="form-control" type="text"
                                        placeholder="Employee Name..." aria-label="Search Input"
                                        value={filterText} onChange={(event) => {
                                            setFilterText(event.target.value)
                                        }} />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <input className="form-control" type="date" aria-label="Search Input" id="filteredDate"
                                        defaultValue={filterDate} onChange={(event) => {
                                            setFilterDate(event.target.value)
                                        }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mb-3" align="right">
                            <ExcelExport data={timelogs} fileName="EveningTimelog"  filterDate={filterDate}/>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    {filteredDepartments && filteredDepartments.length > 0 ? (
                                        filteredDepartments.map(department => {
                                            const departmentUsers = users.filter(user => user.department === department.name)
                                                .filter(user => user.name.toLowerCase().includes(filterText.toLowerCase()));

                                            return (
                                                <div className="mb-4 p-3" key={department.id} style={{border:'1px solid #cfcfcf'}}>
                                                    <h4 className="mt-4 bg-primary p-2 text-white rounded">{department.name || ''}</h4>

                                                    {departmentUsers && departmentUsers.length > 0 ? (
                                                        departmentUsers.map(user => {
                                                            // Filter timelogs by user and department
                                                            const userTimelogs = groupedData[department.name] ? groupedData[department.name][user.id] : null;
                                                            
                                                            return (
                                                                <div key={user.id}> 
                                                                    <h5 className="mt-4 mb-2 adminName">{user.name || ''}</h5>
                                                                    
                                                                    <div className="table-responsive timelogData">
                                                                        <table className="mb-3 table custom-table adminData">
                                                                            <thead className="table-secondary">
                                                                                <tr>
                                                                                    <th>Channel</th>
                                                                                    <th>Billing <br />Type</th>
                                                                                    <th>Meter</th>
                                                                                    <th>Client</th>
                                                                                    <th>Project</th>
                                                                                    <th>Department</th>
                                                                                    <th>Total <br />Hours</th>
                                                                                    <th>Billable <br />Hours</th>
                                                                                    <th className='bigContent'>Billable Description</th>
                                                                                    <th>Non-Billable <br/>Hours</th>
                                                                                    <th className='bigContent'>Non-Billable Description</th>
                                                                                    <th>Date</th>
                                                                                    <th>Modified <br />Date</th>
                                                                                    <th>TL <br /> Assigned</th>
                                                                                    <th>TL <br />Approve</th>
                                                                                    <th className="text-end">Action</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {userTimelogs && userTimelogs.logs.length > 0 ? (
                                                                                    userTimelogs.logs.filter(timelog => user.id === timelog.user_id).map(timelog => {
                                                                                        return(
                                                                                            <tr key={timelog.id} 
                                                                                                    className={timelog.deleted_at ? 'tableDanger' : 
                                                                                                                (timelog.is_approved === 1 ? 'tableSuccess' : '')}>
                                                                                                <td>{timelog.channel || ""}</td>
                                                                                                <td>{timelog.billing_type || ""}</td>
                                                                                                <td>{timelog.meter || "N/A"}</td>
                                                                                                <td>{timelog.client || ""}</td>
                                                                                                <td>{timelog.project || ""}</td>
                                                                                                <td>{timelog.department || ""}</td>
                                                                                                <td>{timelog.time_spend || "00.00"}</td>
                                                                                                <td>{timelog.billable_time || "00.00"}</td>
                                                                                                <td width={200}>{timelog.billable_description || 'N/A'}</td>
                                                                                                <td>{timelog.nonbillable_time || "00.00"}</td>
                                                                                                {/* <td width="400px">{timelog.nonbillable_description ? timelog.nonbillable_description.substring(0, 40) + '...' : ''}</td> */}
                                                                                                <td width="400px">{timelog.nonbillable_description || 'N/A'}</td>
                                                                                                <td>{timelog.time_log_date || ""}</td>
                                                                                                <td>{timelog.updated_at || ""}</td>
                                                                                                <td>{timelog.assignedTLName || ""}</td>
                                                                                                <td>
                                                                                                    {timelog.is_submitted === 1 ? (
                                                                                                        <>
                                                                                                            {(timelog.is_approved === 0 && !timelog.deleted_at)? (
                                                                                                                <div className="tableIcon">
                                                                                                                    <i className="fa fa-thumbs-up" data-bs-toggle="tooltip" 
                                                                                                                        aria-label="fa fa-thumbs-up" data-bs-original-title="fa fa-thumbs-up"
                                                                                                                        onClick={() => {setFilterDate({currentdate});
                                                                                                                                        updateStatus({ tlId: timelog.id, approval: '1' })}}>
                                                                                                                    </i>
                                                                                                                </div>
                                                                                                                ) : (<>{timelog.approved_date || ''}</>)
                                                                                                            }
                                                                                                        </>
                                                                                                        ): ''
                                                                                                    }
                                                                                                </td>
                                                                                                <td className="text-end">
                                                                                                    <div className="dropdown dropdown-action">
                                                                                                        <Link to="#" className="action-icon dropdown-toggle"
                                                                                                            data-bs-toggle="dropdown" aria-expanded="false">
                                                                                                            <i className="material-icons">more_vert</i>
                                                                                                        </Link>
                                                                                                        <div className="dropdown-menu dropdown-menu-right">
                                                                                                            <DeleteComponent 
                                                                                                                url="delete_timelogs"
                                                                                                                id={timelog.id}
                                                                                                                fetchData={fetchTimeLogs} 
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })
                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan="16" align="center">No time logs available</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    <div className="mt-2 mb-4 pb-3" align="right" style={{borderBottom:'1px dashed #b5b3b3'}}>
                                                                        Total : {userTimelogs && userTimelogs.logs.length > 0 ? (
                                                                                <> {userTimelogs.totalBillable.toFixed(2)} Hours </>
                                                                            ) :  (
                                                                                '0 Hours'
                                                                            )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <div style={{borderBottom:'1px solid #e2e3e5'}} className="mb-2 p-2" align="center">No employee found</div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <div className="p-4" align="center">No department found</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AdminEveTimeLog